import { useSourceContext } from "./SourceContext.js";
/**
 * Get the source prop for a field or input by checking if a source context is available.
 * @param {string} source The original source prop
 * @returns {string} The source prop, either the original one or the one modified by the SourceContext.
 * @example
 * const MyInput = ({ source, ...props }) => {
 *   const finalSource = useWrappedSource(source);
 *   return <input name={finalSource} {...props} />;
 * };
 */
export var useWrappedSource = function (source) {
    var sourceContext = useSourceContext();
    return sourceContext.getSource(source);
};
//# sourceMappingURL=useWrappedSource.js.map